export default "__VITE_ASSET__b24878d2__$_?component__"